import { FormValidations } from "features/shared/forms/hooks/useForm";

export const customerTypeFormValidations = (): FormValidations  => {
  return {
    customerType: {
      required: true,
      type: "OnlyRequired",
      requiredMessage: "customerTypeFormValidation.customerType"
    },
    commodity: {
      required: true,
      type: "OnlyRequired",
      requiredMessage: "customerTypeFormValidation.commodity"
    }
  };
}